
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/gdpr",
      function () {
        return require("private-next-pages/gdpr.tsx");
      }
    ]);
  